export const extensionRoutes = [  {
    path: 'extensions/product-reviews',
    loadChildren: () => import('./extensions/38d892f6b9549b717359a5ac10149c5fa656ecf72d7339822658895635cf490c/routes'),
  }];
